import { render, staticRenderFns } from "./BarOrderModeTakeAway.vue?vue&type=template&id=c198afd4&scoped=true"
import script from "./BarOrderModeTakeAway.vue?vue&type=script&lang=js"
export * from "./BarOrderModeTakeAway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c198afd4",
  null
  
)

export default component.exports